import { AfterContentInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { of } from 'rxjs';
import { catchError, finalize, switchMap } from 'rxjs/operators';

import { OpenApiDataService } from '../services';
import { OpenApiV3 } from '../models';
import { Logger } from '../logger';
import SwaggerUI from 'swagger-ui';
import { ApiDescription } from '../models/model/api-description';

@Component({
  selector: 'app-openapi-render',
  templateUrl: './openapi-render.component.html',
  styleUrls: ['./openapi-render.component.scss']
})
export class OpenapiRenderComponent implements OnInit,AfterContentInit {

  errorMessage: string;

  api: ApiDescription;

  dev_doc: string;

  workInProgress: boolean = true;

  @ViewChild('swaggerUi') custApiDocElement: ElementRef | undefined;
  @ViewChild('docContentAnchor') private docContentAnchor : ElementRef | undefined;

  private apiName: string;

  constructor(
    private route: ActivatedRoute,
    private openApiDataService: OpenApiDataService,
  ) { }

  ngOnInit(): void {
    this.apiName = this.route.snapshot.params['name'];
    Logger.log('apiName', this.apiName);

  }

  ngAfterContentInit(): void {
    this.openApiDataService.ondbLoaded.subscribe(_ => {
      this.api = this.openApiDataService.getApi(this.apiName);
      if( ! this.api ) {
        Logger.debug(`no data returned for "${this.apiName}"`);
        if( ! this.workInProgress ) {
          this.errorMessage = `Error: no data for "${this.apiName}"`;
        }
        return;
      }


      this.openApiDataService.getApiDefinition(this.apiName)
      .pipe(
        catchError(error => {
          Logger.error('catchError', error)
          if (error.error instanceof ErrorEvent) {
            this.errorMessage = `Error: ${error.error.message}`;
          } else {
            this.errorMessage = `Error: ${error.message ? error.message : error}`;
          }
          return of<OpenApiV3>(null);
        }),
        finalize(() => {
          this.workInProgress = false;
        }),
        switchMap(r => {
          if (!r) return;

          this.errorMessage = null;

          Logger.debug('r', r);

          Logger.debug('this.custApiDocElement', this.custApiDocElement);
          const ui = SwaggerUI({
            spec: r,
            domNode: this.custApiDocElement?.nativeElement,
            supportedSubmitMethods: []
          })

          return this.openApiDataService.getApiDeveloperDoc(this.apiName);
        }),
      )
      .subscribe(doc => {
        if (!doc) return;

        this.errorMessage = null;

        Logger.debug('doc', doc);
        this.dev_doc = doc;
      })

    })
  }

  onMarkdownError(event) {
    Logger.error('MARKDOWN', event);
  }

  scrollToDocSection() {
    // Logger.log(this.docContentAnchor);
    this.docContentAnchor?.nativeElement?.scrollIntoView();
  }
}
